import { render, staticRenderFns } from "./ServiceTypeSettings.vue?vue&type=template&id=5a7f9ca8&scoped=true"
import script from "./ServiceTypeSettings.vue?vue&type=script&lang=js"
export * from "./ServiceTypeSettings.vue?vue&type=script&lang=js"
import style0 from "./ServiceTypeSettings.vue?vue&type=style&index=0&id=5a7f9ca8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7f9ca8",
  null
  
)

export default component.exports